export default {
  pt_BR: {
    Fields: {
      cpf: {
        required: 'O campo CPF é obrigatório.',
        username: 'Por favor, insira um CPF válido.',
        cpf: 'Informe-nos um CPF válido'
      },
      name: {
        required: 'Por favor, preencha com seu nome'
      },
      document: {
        required: 'Qual o seu CPF?',
        cpf: 'Informe-nos um CPF válido',
        userNotExists: 'Este CPF já está cadastrado',
      },
      phone: {
        required: 'Preencha com o seu celular',
        min: 'Preencha com um celular válido',
        phoneStartsWithNine: 'Preencha com um celular válido'
      },
      email: {
        required: 'Preencha com o seu e-mail principal',
        email: 'Preencha com um e-mail válido',
        userNotExists: 'Este e-mail já está cadastrado',
      },
      username: {
        required: 'Por favor, preencha com seu CPF ou e-mail',
        username: 'Por favor, preencha com um CPF ou e-mail válidos',
      },
      usernameRecover: {
        required: 'Por favor, preencha com seu CPF ou e-mail',
        username: 'Por favor, preencha com um CPF ou e-mail válidos',
        userExists: 'Não encontramos nenhum usuário com essa informação',
      },
      password: {
        min: 'Sua senha deve conter no mínimo 6 caracteres',
        required: 'Preencha com uma senha',
      },
      postal_code: {
        min: 'CEP inválido',
        required: 'Preencha com o CEP',
      },
      street_name: {
        required: 'Preencha com o endereço',
      },
      neighborhood: {
        required: 'Preencha com o bairro',
      },
      city: {
        required: 'Preencha com a cidade',
      },
      state: {
        required: 'Preencha com o estado',
      },
      street_number: {
        required: 'Qual o número?',
      },
      acceptTerms: {
        required: 'Por favor, aceite os termos de uso.'
      },
      cardNumber: {
        required: 'Por favor, preencha com o número do seu cartão',
        isCardNumberValid: 'Por favor, preencha um número de cartão válido'
      },
      cardOwnerName: {
        required: 'Preencha com o nome que está no cartão',
      },
      cardExpirationDate: {
        required: 'Preencha a data de vencimento',
        isCardExpiryDateValid: 'Preencha uma data de vencimento válida',
      },
      cardCVV: {
        required: 'Qual o CVV?',
        min: 'Preencha um cvv válido',
      },
      cardInstallment: {
        required: 'Selecione uma parcela',
      },
      cardSelected: {
        required: 'Selecione um cartão',
      },
      coupon: {
        exists: 'Código inválido ou expirado',
        required: 'Cupom inválido',
      },
      digit: {
        required: 'Por favor, preencha o dígito',
      },
      agency: {
        required: 'Por favor, preencha a agência',
      },
      account: {
        required: 'Por favor, preencha a conta',
      },
      third_party_cpf: {
        required: 'Por favor, preencha o CPF do responsável',
      },
      birthday: {
        required: 'Data de nascimento obrigatório',
        isOverEighteenYearsOld: 'Obrigatório ter 18 anos ou mais'
      },
      amount: {
        required: 'Preencha o valor a ser pago no cartão',
        minValueAmountToPay: 'Valor mínimo a ser pago é de R$ 2,00',
      },
    },
  },
};
